import React from 'react';

function PremiumArticlesListLoading({ showFeatured = false }) {
  const skeletonItems = [1, 2, 3];

  return (
    <section className="premium-articles-list-section skeleton-loader">
      <div className="container">
        <div className="premium-articles-list">
          {skeletonItems.map((item, index) => {
            const isFirst = index === 0 && showFeatured;
            return (
              <div
                key={item}
                className={`premium-article-card-skeleton ${
                  isFirst ? 'featured' : ''
                }`}
              >
                {isFirst ? (
                  <>
                    <div className="premium-article-content-skeleton">
                      <div className="premium-article-badge-skeleton" />
                      <div className="premium-article-title-skeleton" />
                      <div className="premium-article-description-skeleton" />
                      <div className="premium-article-description-skeleton short" />
                      <div className="premium-article-meta-skeleton">
                        <div className="premium-article-meta-item-skeleton" />
                        <div className="premium-article-meta-separator-skeleton" />
                        <div className="premium-article-meta-item-skeleton" />
                      </div>
                    </div>
                    <div className="premium-article-image-skeleton" />
                  </>
                ) : (
                  <>
                    <div className="premium-article-content-skeleton">
                      <div className="premium-article-badge-skeleton" />
                      <div className="premium-article-title-skeleton" />
                      <div className="premium-article-description-skeleton" />
                      <div className="premium-article-meta-skeleton">
                        <div className="premium-article-meta-item-skeleton" />
                        <div className="premium-article-meta-separator-skeleton" />
                        <div className="premium-article-meta-item-skeleton" />
                      </div>
                    </div>
                    <div className="premium-article-image-skeleton" />
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default PremiumArticlesListLoading;
